module.exports = __webpack_public_path__ + "static/img/s6.71256df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/s6.png
// module id = N2Ta
// module chunks = 1